import styled from "styled-components";

export const PaymentComponentWrap = styled.div`
  color: #141823;
  border-radius: 0.8rem;
  background-color: #ffffff;

  .pymntCmp_hdng {
    display: flex;
    justify-content: space-between;
    padding: 1.5rem 2rem;
    border-bottom: 0.1rem solid #eef4fd;
  }
  .viewDtl {
    position: relative;
  }

  .font12 {
    font-size: 1.2rem;
  }

  .font16 {
    font-size: 1.6rem;
    color: #141823;
  }

  .font22 {
    font-size: 2.2rem;
  }

  .lineHeight28 {
    line-height: 2.8rem;
  }

  .lightGrey {
    color: #898b91;
  }

  .greenText {
    color: #2bac36;
  }


  label {
    width: 100%;
  }

  .pymntCmp_btm {
    padding: 0 2rem 1rem;
  }
`;


export const Strip = styled.div`
  padding: 0.5rem 5rem;
  color: #18a160;
  font-size: 1.2rem;
  border-radius: 0.4rem;
  background-color: #e9f6ea;
  text-align: center;
`;

export const Radiobox = styled.span`
  width: 100%;
  padding: 1.6rem;

  &.active {
    background-color: #fff9f6;
  }
  display: inline-flex;
  position: relative;

  label {
    position: relative;
    padding-left: 2.8rem;
    line-height: 2rem;
    display: inline-flex;
    cursor: pointer;
  }

  [type="radio"] {
    position: absolute;
    left: -9999px;
  }

  label:after {
    content: "";
    width: 1.2rem;
    height: 1.2rem;
    position: absolute;
    top: 0.4rem;
    left: 0.3rem;
    border-radius: 100%;
    opacity: 0;
    transform: scale(0);
    transition: all 0.2s ease;
    background: #2276e3;
  }

  label:before {
    content: "";
    width: 1.8rem;
    height: 1.8rem;
    position: absolute;
    left: 0;
    top: 0.1rem;
    border-radius: 100%;
    background: #fff;
    border: 0.1rem solid #647a97;
  }

  [type="radio"]:checked + label:before {
    border: 0.1rem solid #2276e3;
  }

  [type="radio"]:checked + label:after {
    opacity: 1;
    transform: scale(1);
  }

  @media (min-width: 768px) {
    /* display: flex; */
  }

  &.disabled {
    background: #eee;
    color: #666;
  }
`;

export const BookNowBtn = styled.button`
  width: ${(p) => (p.btnWidth ? p.btnWidth : "")};
  height: ${(p) => (p.btnHeight ? p.btnHeight : "3.3rem")};
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
  background-color: ${(p) => (p.btnBgColor ? p.btnBgColor : "#ff6d38")};
  font-family: 'Rubik';
  font-size: ${(p) => (p.fontSize ? p.fontSize : "1.4rem")};
  color: ${(p) => (p.btnColor ? p.btnColor : "#fff")};
  font-weight: 600;
  outline: 0;
  border: 0;
  cursor: pointer;
  width: 100%;
  height: 4.7rem;
  font-size: 1.6rem;
  font-weight: 600;
`;
